(function (global) {
    class Manager {
        constructor(config) {
            this.init(config);
        }

        init(config) {
            this.options = new NS.Utils.OptionsResolver(config);
            // noinspection JSPotentiallyInvalidConstructorUsage
            this.windowsManager = new dhtmlXWindows(this.options.getOption("container-id", null));
        }

        createWindow(config) {
            const windowOptions = new NS.Utils.OptionsResolver(config);
            const id = windowOptions.getOption("id");
            const position = windowOptions.getOption("position", {
                "x": 100,
                "y": 100
            });
            const size = windowOptions.getOption("size", {
                "width": 500,
                "height": 300
            });

            if (!id) {
                throw new Error("Cannot create window without ID.");
            }

            if (this.windowsManager.isWindow(id)) {
                throw new Error("Window with id: " + id + " already exists.");
            }

            const dhtmlxWindow = this.windowsManager.createWindow(id, position.x, position.y, size.width, size.height);

            return new NS.Window.Control(dhtmlxWindow, config);
        }

        dhtmlxObject() {
            return this.windowsManager;
        }
    }

    global.NS = global.NS || {};
    global.NS.Window = global.NS.Window || {};
    global.NS.Window.Manager = Manager;
})(window);
